import { Injectable, inject } from '@angular/core';
import {SharedModalControllerService} from '@shared/services/shared-modal-controller.service';
import {TeamRegisterPage} from '@team/pages/register/team-register-page';
import {TeamLoginPinRegisterUserDialogComponent} from '@team/pages/register/components/pin-register-user-dialog/team-login-pin-register-user-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TeamRegisterSideEffectsService {
  private _sharedModalControllerService = inject(SharedModalControllerService);


  askRegistrationData(currentEmail: string) {
    this._sharedModalControllerService.showModal(
      TeamRegisterPage,
      '',
      {
        currentEmail,
      }
    );
  }

  askRegistrationPinGuest(passwordBase64: string, email: string) {
    this._sharedModalControllerService.closeModal();
    this._sharedModalControllerService.showModal(TeamLoginPinRegisterUserDialogComponent, '', {
      passwordBase64,
      email,
    });
  }
}
